// Real invitation data

export const LOGO_URL = "/logo.png";

export const COUPLE = {
    groom: "Pakkar Mohammed Rayyan",
    bride: "Vellore Zuha Siman",
    inshallah: "In Shaa Allah",
    heroDate: "14 · 15 · 16 August 2026",
    hostLine:
        "Mrs. and Mr. Pakkar Naveed Ahmed request your presence at the Nikah of",
    groomLineage: [
        "Paternal grandson of Late Janab Pakkar Abdul Khayoom Sb",
        "Maternal grandson of Late Janab Koona Farooq Ahmed Sb",
    ],
    brideLineage: [
        "Daughter of Janab Vellore Mohammed Zaid Sb",
        "Paternal granddaughter of Janab Vellore Noorullah Sb",
        "Maternal granddaughter of Janab Ajman Shafeeq Ahmed Sb",
    ],
};

export const BISMILLAH_TRANSLATION =
    "In the name of Allah, the Most Gracious, the Most Merciful";

const MAPS = {
    nkz: "https://maps.google.com/maps/place//data=!4m2!3m1!1s0x3bada9b63fa3fa49:0xbf97bc209751b0d4?entry=s&sa=X&ved=2ahUKEwjBtcbW0eqVAxX5WHADHWe_GHYQ4kB6BAgREAA",
    masjid: "https://maps.google.com/maps/place//data=!4m2!3m1!1s0x3bada9a6033d0e37:0x2465132c35165eb7?entry=s&sa=X&ved=2ahUKEwiq0J2S0eqVAxVRSmwGHTI6FjMQ4kB6BAg-EAA",
    kpa: "https://maps.google.com/maps/place//data=!4m2!3m1!1s0x3bada9488234b5a1:0xc3eaf62e6be4364b?entry=s&sa=X&ved=2ahUKEwj00J7j0eqVAxWTSWwGHQ-UO1gQ4kB6BAgYEAA",
    zaitoon: "https://maps.google.com/maps/place//data=!4m2!3m1!1s0x3a526778abbb4f59:0x31158f7354e483f7?entry=s&sa=X&ved=2ahUKEwjH1dP80eqVAxUzUGwGHcY9Kk8Q4kB6BAgREAA",
};

export const EVENTS = [
    {
        id: "shukrana",
        day: "Day I",
        title: "Shukrana",
        subtitle: "An evening of gratitude",
        date: "Friday, 14 August 2026",
        time: "7:00 PM onwards",
        startISO: "20260814T190000",
        endISO: "20260814T230000",
        venueName: "NKZ Convention Hall",
        venueAddress: "Valiampet, Vaniyambadi",
        mapsUrl: MAPS.nkz,
        description:
            "An intimate evening of gratitude — soft light, warm greetings, and heartfelt prayers amongst family and dear friends.",
    },
    {
        id: "nikah",
        day: "Day II",
        title: "Nikah",
        subtitle: "The solemnisation",
        date: "Saturday, 15 August 2026",
        time: "12:15 PM, followed by lunch",
        startISO: "20260815T121500",
        endISO: "20260815T160000",
        venueName: "Masjid-e-Madinul-Uloom",
        venueAddress: "Vaniyambadi",
        mapsUrl: MAPS.masjid,
        gents: {
            venueName: "NKZ Convention Hall",
            address: "Valiampet, Vaniyambadi",
            mapsUrl: MAPS.nkz,
        },
        ladies: {
            venueName: "KPA Palace",
            address: "New Town, Vaniyambadi",
            mapsUrl: MAPS.kpa,
        },
        description:
            "The sacred exchange of vows at Masjid-e-Madinul-Uloom, followed by lunch — witnessed by loved ones, blessed by prayers.",
    },
    {
        id: "valima",
        day: "Day III",
        title: "Valima",
        subtitle: "A celebration of union",
        date: "Sunday, 16 August 2026",
        time: "7:30 PM onwards",
        startISO: "20260816T193000",
        endISO: "20260816T233000",
        venueName: "Zaitoon Signature",
        venueAddress: "Valluvar Kottam High Road, Nungambakkam, Chennai",
        mapsUrl: MAPS.zaitoon,
        description:
            "A luxurious evening banquet in celebration of the newlyweds — an evening of feast and blessings.",
    },
];

export const FOOTER_MESSAGE =
    "With prayers and gratitude, we look forward to celebrating this special occasion with you.";
